module.exports = "pegasus_template/assets/custom-1-twitter.png";